/**
 * created on : 2019.04.08
 * 广电广电文稿-串联单详情页
 */
'use strict';
angular.module('broadcastSeriesSheetPreviewModule', [])
    .controller('broadcastSeriesSheetPreviewCtrl', ['$scope', 'initeditctrBtnsService', 'trsHttpService', '$q', '$stateParams', '$state', 'localStorageService', 'modalDialog', 'editIsLock', 'broadcastService', 'trsPrintService', '$sessionStorage', 'editingCenterService', function($scope, initeditctrBtnsService, trsHttpService, $q, $stateParams, $state, localStorageService, modalDialog, editIsLock, broadcastService, trsPrintService, $sessionStorage, editingCenterService) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                fromsearch: $stateParams.fromsearch,
                btnRights: {}
                // num: [1, 2, 23]
            };
            $scope.page = {
                PAGESIZE: 20,
                PAGECOUNT: '',
                ITEMCOUNT: '',
                CURRPAGE: 1,
            };
            $scope.data = {
                userData: [],
                detail: '',
                editPath: broadcastService.getEditAndPreviewPath().edit,
                selectedArray: [],
                printResult: [],
            };
            initBtnRights();
        }

        function initData() {
            getAllUsers().then(function() {
                return requestData();
            }).then(function() {
                getSeriesSheetList();
            });
        }

        /**
         * [initBtnRights description] 初始化按钮权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            let rightsMethod = ['broadcast.daibian', 'broadcast.daishen', 'broadcast.yiqianfa'];
            initeditctrBtnsService.initTvData($stateParams.broadcastchannelid, rightsMethod[$stateParams.broadcastplatform]).then((data) => {
                data.forEach((item, index) => {
                    $scope.status.btnRights[item.OPERNAME.split('.')[2]] = true;
                });
            });

            /* initeditctrBtnsService.initIwoData(methodnameArray[$stateParams.iwoplatform]).then(function(data) {
                data.forEach((item, index) => {
                    $scope.status.btnRights[item.OPERNAME.split(".")[2]] = true;
                });
            });*/
        }

        /**
         * [getAllUsers description] 获取全部系统用户
         * @return {[type]} [description]
         */
        function getAllUsers() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'queryUsersByName',
                IsSearchAll: true,
                Name: ''
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.userData = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [requestData 获取详情]
         * @return {[type]} [description]
         */
        function requestData() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_broadcast',
                methodname: 'getWenGaoDoc',
                MetaDataId: $stateParams.broadcastmetadataid,
                fromsearch: $stateParams.fromsearch
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.detail = data;
                document.title = data.TITLE;
                defer.resolve();

            });
            return defer.promise;
        }

        /**
         * [selectAll 全选]
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.items.length != $scope.data.selectedArray.length && $scope.data.items.length > 0) {
                $scope.data.selectedArray = [];
                for (var i = 0; i < $scope.data.items.length; i++) {
                    $scope.data.selectedArray.push($scope.data.items[i]);
                }
            } else {
                $scope.data.selectedArray = [];
            }
        };

        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [getSeriesSheetList 获取串联单列表]
         * @return {[type]} [description]
         */
        function getSeriesSheetList() {
            var params = {
                serviceid: 'mlf_broadcast',
                methodname: 'queryQuoteDocLists',
                SeriesDocId: $stateParams.broadcastmetadataid
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (angular.isArray(data)) {
                    $scope.data.items = data;
                } else {
                    $scope.data.items = data.DATA;
                }
            });
        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) { // 88
            var pageTurningData;
            pageTurningData = JSON.parse(localStorageService.get('broadcastSeriesSheetPreview'));
            var metadataid = $stateParams.broadcastmetadataid;
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (pageTurningData[i].METADATAID === metadataid ||
                    pageTurningData[i].DOCID === metadataid ||
                    pageTurningData[i].MLFID === metadataid) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            $state.go($state.current.name, {
                broadcastchnldocid: toPageData.CHNLDOCID,
                broadcastchannelid: toPageData.CHANNELID,
                broadcastmetadataid: toPageData.METADATAID,
                broadcasttypeid: toPageData.DOCTYPEID,
                broadcastsiteid: $stateParams.broadcastsiteid,
                broadcastplatform: $stateParams.broadcastplatform
            }, {
                reload: true
            });
        };

        /**
         * [edit description:编辑前请求解锁]
         * @param  {[type]} item [description:稿件对象]
         */
        $scope.edit = function(item) {
            $scope.status.isESSearch = false;
            editIsLock.isLock($scope.data.detail, 16).then(function(data) {
                var editPath = $scope.data.editPath[$scope.data.detail.DOCTYPEID];
                var editParams = {
                    broadcastchannelid: $scope.data.detail.CHANNELID,
                    broadcastchnldocid: $stateParams.broadcastchnldocid,
                    broadcastmetadataid: $scope.data.detail.METADATAID,
                    broadcastsiteid: $stateParams.broadcastsiteid,
                    broadcastplatform: $stateParams.broadcastplatform
                };
                // var editUrl = $state.href(editPath, editParams);
                if (data.ISLOCK == 'false') {
                    $state.go(editPath, editParams);
                    // $window.open(editUrl);
                } else {
                    editIsLock.checkUnlockPermissions($scope.data.detail, data).then(function() {
                        // $window.open(editUrl);
                        $state.go(editPath, editParams);
                    });

                    /* modalDialog.alertType("稿件已经被【" + data.LOCKUSER + "】锁定,是否强制解锁", "", "warning", true, function() {
                        editIsLock.forceDeblocking(item).then(function(data) {
                            $window.open(editUrl);
                        });
                    }, function() {});*/
                }
            });
        };

        /**
         * [highestMedia description：头部- 退出登录]
         */
        $scope.logout = function() {
            // localStorageService.remove('currLoginUser'); // session改变
            $sessionStorage.remove('currLoginUser');
            // localStorageService.remove('mlfCachedUser'); // session改变
            $sessionStorage.remove('mlfCachedUser');
            $('#unreadPrompt_js').hide(); // 关闭传稿提示框
            $.ajax({
                url: '/wcm/logout.jsp',
                method: 'get',
                async: false,
                success: function() {},
                error: function() {}
            });
            $state.go('front.editctr.iWo.personalManuscript', {}, { reload: true });
        };

        /**
         * [printBtn 打印]
         * @return {[type]} [description]
         */
        $scope.printBtn = function() {
            $scope.status.isESSearch = false;
            // if (checkDraftType($scope.status.draftType.subject)) {
            //     modalDialog.alertType("所选稿件中有专题稿，无法打印", '', "error", false);
            //     return;
            // }
            // angular.forEach($scope.data.selectedArray, function(value, key) {
            // requestPrintVersion(value).then(function(data) {
            requestPrintData();
            // });
            // });
        };

        // /**
        //  * [requestPrintVersion 打印流程请求]
        //  * @param  {[type]} item [description]
        //  * @return {[type]}      [description]
        //  */
        // function requestPrintVersion(item) {
        //     var defer = $q.defer();
        //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), {
        //         serviceid: "mlf_metadatalog",
        //         methodname: "query",
        //         MetaDataId: item.METADATAID
        //     }, 'get').then(function(data) {
        //         defer.resolve(data.DATA);
        //     });
        //     return defer.promise;
        // }

        /**
         * [requestPrintData 打印请求详情]
         * @param  {[type]} item    [description]
         * @param  {[type]} version [description]
         * @return {[type]}         [description]
         */
        function requestPrintData() {
            var params = {
                'serviceid': 'mlf_broadcast',
                'methodname': 'queryQuoteDocLists',
                'SeriesDocId': $scope.data.detail.METADATAID
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = $scope.data.detail;
                result.ITEMS = $scope.data.items;
                // data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                // if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                trsPrintService.trsTvPrintDocument($scope.data.printResult);
                $scope.data.printResult = [];
                // }
            });
        }

        /**
         * [goToEdit description]
         *
         * @return  {[type]}  [return description]
         */
        $scope.goToEdit = function() {
            var exartParams = {
                broadcastchnldocid: $stateParams.broadcastchnldocid,
                broadcastsiteid: $stateParams.broadcastsiteid,
                broadcastplatform: $stateParams.broadcastplatform,
                mediaType: '16'
            };
            editingCenterService.routerToEditorWithLock(angular.extend($scope.data.detail, exartParams));
        };
    }]);
